export default __webpack_public_path__ + "static/media/template16.ef1c7b6a.svg";